import { fromEvent, Observable, Subject, timer } from "rxjs";
import { Inject, Injectable } from "@angular/core";
import { environment } from '../../environments/environment';
import { VgUtils } from "../_modules/player/core";
import { DOCUMENT } from "@angular/common";

declare var injectResouceHost;

@Injectable({
    providedIn: "root"
})
export class Utility {

    constructor(@Inject(DOCUMENT) private document: Document) {


    }
    prizeList = [
        {
          name: '巴黎世家',
          image: './assets/images/bargain-event/lottery/prize-0.png',
          longName:"巴黎世家单肩包"
        },
        {
          name: '4070 Ti',
          image: './assets/images/bargain-event/lottery/prize-1.png',
          longName:"RTX4070Ti"

        },
        {
          name: '索尼相机',
          image: './assets/images/bargain-event/lottery/prize-2.png',
          longName:"SONY美颜相机"

        },
        {
          name: 'PS5',
          image: './assets/images/bargain-event/lottery/prize-3.png',
          longName:"PS5"
        },
        {
          name: 'iPhone 14',
          image: './assets/images/bargain-event/lottery/prize-4.png',
          longName:"iPhone14"
        },
        {
          name: '外星人电脑',
          image: './assets/images/bargain-event/lottery/prize-5.png',
          longName:"外星人M16"

        },
      ];

      getRandomPrize()
      {
        const randomIndex = Math.floor(Math.random() * this.prizeList.length);
        return this.prizeList[randomIndex];
      }
    getAbsUrl(resource: string) {
        if (!injectResouceHost) {
            return resource;
        }
        if (resource) {

            if (resource.indexOf("http") == -1) {
                return injectResouceHost + this.toPath(resource.replace(/\.\.\//g, "").replace("./", "/"));
            }
        }
        return resource;
    }
    toPath(path) {
        if (path[0] == "/") {
            return path;
        }
        return "/" + path;
    }

    getZoomRatio() {
        return this.isMac() ? 1 : this.getWindow().innerWidth < 1366 ? (1366 / this.getWindow().innerWidth) : this.getWindow().innerWidth > 2560 ? (1920 / this.getWindow().innerWidth) : 1; // innerWidth如果小于1366启用，使用最小尺寸;大于2560启用，使用最大尺寸

    }
    getLocation() {
        return this.document.location;
    }
    getDocument() {
        return this.document;
    }

    getWindow() {
        return this.document.defaultView;
    }


    isMac() {
        return /macintosh|mac os x/i.test(navigator.userAgent);
    }

    isSafari() {
        return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    }
    private siteConfig = null;
    preLoadPlaySecond = null;
    public get getSiteConfig(): {
        title: string,
        siteKey: string,
        enableAndroidDownload: boolean,
        enableIOSDonwload: boolean,
        enableContact: boolean,
        hidecinema: number,
        hideAds: boolean,
        copyRight: string,
        appDownoloadKey: string,
        enableServerDownloadUrl: boolean,
        appDownloadLink: string,
        customDownloadInfo: any,
        tvApkLink: string
    } {
        return this.siteConfig || this._getSiteConfig;
    }
    private get _getSiteConfig() {
        this.siteConfig = environment;
        if (environment.alternativeConfig != null && environment.alternativeConfig.length > 0) {
            var site = this.GetHost("{Host}");
            var index = environment.alternativeConfig.findIndex(p => p.site == site);
            if (index > -1) {
                this.siteConfig = {
                    ...
                    environment,
                    ...environment.alternativeConfig[index]
                };
                delete this.siteConfig.alternativeConfig;
            }
            else {
                // this.siteConfig = {
                //     title:environment.title,
                //     siteKey:""
                // };
            }
            // console.log(this.siteConfig)
        }
        else {
            // this.siteConfig = {
            //     title:environment.title,
            //     siteKey:""
            // };
        }

        return this.siteConfig;
    }


    ///当前文档是否可见
    isDocumentVisible = true;
    resourceHost = this.GetHost("static.{Host}");
    isNews = false;
    canViewPublic = true;
    // static userToken = {};
    canUseMaster = environment.production ? !((VgUtils.isiOSDevice() || VgUtils.IsMac()) && VgUtils.isSafari()) : false;
    ///生成一串随机号
    public GUID() {
        return (new Date()).getTime().toString(36) + Math.random().toString(36).slice(2)

    }



    ///一些影响显示的，让bot更快抓取
    public isBot() {
        // return true;

        const re = new RegExp("(googlebot\/|bot|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)", 'i');
        var userAgent = navigator.userAgent;
        if (re.test(userAgent)) {
            return true;
        }
        // console.log(re.test(userAgent),userAgent)
        return false;
    }
    public openList(element: HTMLElement, insideCall, outSideCall) {
        return fromEvent(document, "click").subscribe(event => {
            if (!element.contains(event.target as HTMLElement)) {
                console.log("click outside");
                if (outSideCall != null)
                    outSideCall(event.target);
            }
            else {
                if (insideCall != null)
                    insideCall(event.target);
                console.log("click inside");
            }
        })
    }

    public isSameRoute(fromUrl, toUrl) {
        let fromPath = fromUrl.split('?')[0];
        let toPath = toUrl.split('?')[0];
        if (fromPath == toPath) {
            return true;
        }
        return false;
    }

    // public static _start:number;
    // public static Start()
    // {
    //    Utility._start = Date.now();
    // }

    // public static Stop()
    // {
    //     let totalSecond = Date.now() - Utility._start;
    //     console.log(`usage:${totalSecond }s`)
    // }
    /*
    ** 系统主题为深色
    */
    public isSystemDark() {
        var result = false;
        try {
            if (this.getWindow().matchMedia && this.getWindow().matchMedia('(prefers-color-scheme: dark)').matches) {
                result = true;

            }
        }
        catch (err) {

        }
        return result;
    }
    /*
    ** 当前时间是否应用深色模式
    */
    public isTimeDark() {
        if (environment.switchBaseOnTime) {
            var result = false;
            var today = new Date();
            var time = today.getHours();
            if (time >= 20 || time <= 6) //apply dark mode
            {
                result = true;
            }
            return result;
        }
        return false;

    }
    /*
    ** 当前是否为深色模式
    */
    public isDarkMode(timeConsume = true) {
        var result = this.isSystemDark();
        if (!result && timeConsume) {
            result = this.isTimeDark();
        }

        return result;
    }
    public getPromotion(product) {
        var result = [];
        for (var i = 0; i < product.promotions.length; ++i) {
            result.push(product.promotions[i].promotionCode);
        }
        return result.join("|");
    }
    // public static setToken(value) {
    //     Utility.userToken = value;
    // }
    // public static getToken() {
    //     return Utility.userToken;
    // }
    public GetSafeResource(data) {
        if (!!data && (data.indexOf("http:") > -1 || data.indexOf("https:") > -1)) {
            return data.replace("http:", "https:");
        }
        return "https:" + data;
    }
    public GetSearchKey() {
        return decodeURIComponent(this.GetCurrentLocation().split("?")[0]
            .replace("/search/", "")
            .replace("/search", "")
        )
    }
    public isKeyEnter(event) {
        if (null != event && (event.key == "Enter" || event.key == 13)) {
            return true;
        }
        return false;
    }
    public staticResource(data) {
        return data ? data.replace("static.dnvod.tv", this.resourceHost) : "";
    }
    getTimeSpan(data) {
        var sec_num = parseInt(data + "", 10); // don't forget the second param
        var hours: any = Math.floor(sec_num / 3600);
        var minutes: any = Math.floor((sec_num - (hours * 3600)) / 60);
        var seconds: any = sec_num - (hours * 3600) - (minutes * 60);

        if (hours < 10) { hours = "0" + hours; }
        if (minutes < 10) { minutes = "0" + minutes; }
        if (seconds < 10) { seconds = "0" + seconds; }
        return hours + ':' + minutes + ':' + seconds;
    }
    GetContent(html) {
        return html.replace(/<\/?[^>]+(>|$)/g, "")
            .replace(/&nbsp;/g, "")
            .trim()

    }
    isIphoneDevice() {
        const result = this._isIphoneDevice();
        return result
    }

    _isIphoneDevice() {

        const iDevices = [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod',
        ];
        if (navigator && !!navigator.platform) {
            while (iDevices.length) {
                if (navigator.platform === iDevices.pop()) { return true; }
            }
        }
        if (
            navigator &&
            navigator.userAgent &&
            /iphone|ipad/i.test(navigator.userAgent))
            return true;

        var ua = navigator.userAgent.toLowerCase();
        var isiOS = ua.indexOf('macintosh') > -1 && 'ontouchend' in document;
        //   console.log(isiOS)
        return isiOS;
    }

    public GetPublicRelation() {
        return this.GetHost("https://static.{Host}/images/public.jpg?v=2")
    }
    public GetCharge() {
        return this.GetHost("https://img.{Host}/wechat/?type=charge")
    }
    public GetVideoCDN(str) {
        return str.replace("{Host}", "s1-a1.dnvodcdn.me");
    }

    public defaultHost = environment.cinema == 2 ? "wyav.tv" : "ifsp.tv";

    public GetHost(str: string = "", isCookie = false) {
        var result = "";
        result = !!this.getLocation() && !!this.getLocation().hostname ? this.GetDomain(this.getLocation().hostname) : this.defaultHost;
        if (environment.app) {
            result = "apiregion721.xyz";
        }
        if (!!str) {
            result = str.replace(/{Host}/g, result);
        }
        return result;
    }
    /*
    ** 将字符串转成json
    */
    parseJSON(str) {
        var pairs = str ? str.split('&') : [];
        var result = {};
        pairs.forEach(function (pair) {
            pair = pair.split('=');
            var name = pair[0]
            var value = pair[1]
            if (name.length)
                if (result[name] !== undefined) {
                    if (!result[name].push) {
                        result[name] = [result[name]];
                    }
                    result[name].push(value || '');
                } else {
                    result[name] = value || '';
                }
        });
        return (result);
    }

    isClickOnBack = false;

    //public static isCovered = false;
    ///指示键盘是否出现
    isKeyboard = false;

    ///指示为True时，不要加载
    IsPreventLoad(): boolean {
        if (this.getLocation().hash && this.getLocation().hash.indexOf("navurl_") > -1)
            return true;
        return false;
    }
    replaceAll(str: string, from: string, to: string): string {
        return str.replace(new RegExp(from, 'g'), to);
    }

    getImage(img) {
        if (img && img.indexOf("http") > -1) {
            return img;
        }
        else {
            return "https:" + img;
        }
    }

    // getChromeVersion(agent) {
    //     agent = agent == null ? navigator.userAgent : agent;
    //     var raw = agent.match(/Chrom(e|ium)\/([0-9]+)\./);
    //     return raw ? parseInt(raw[2], 10) : 0;
    // }


    public GetDomain(url, subdomain = false) {
        subdomain = subdomain || false;

        url = url.replace(/(https?:\/\/)?(www.)?/i, '');

        if (!subdomain) {
            url = url.split('.');

            url = url.slice(url.length - 2).join('.');
        }

        if (url.indexOf('/') !== -1) {
            return url.split('/')[0];
        }

        return url;
    }
    /**
     * 获取当前位置,显示
     */
    public GetCurrentLocation() {
        var path = this.getLocation().pathname;
        var index = path.indexOf("/www/");
        if (index > -1) {
            path = path.substring(index + 4);
        }
        return path + this.getLocation().search;
    }


    /**
     * 获取路径
     * @param cid
     * @param path
     */
    public GetPath(cid, path) {
        var result = "/movie";
        switch (cid) {
            case 0: break;
            case 1: result = "/movie";
                break;
            case 2: result = "/adult";
                break;
        }
        return result + path;
    }
    public IsFullScreen = false;



    /**
    ** 获取非空集合
    */
    public Split(str: string, character: string) {
        var list = str.split(character);
        var result = [];
        for (var index in list) {
            if (!!list[index])
                result.push(list[index]);
        }
        return result;
    }
    public ToNameList(str: string, character: string) {
        return this.CaptilizeMe(this.Split(str, character));
    }
    public CaptilizeMe(list) {
        var result = [];
        if (!!list && list.length) {
            for (var index in list) {
                var data = { key: "", name: "" };
                var nameList = list[index].split('.');
                if (nameList.length > 1) {
                    //console.log(nameList);

                    var better = "";
                    for (var j in nameList) {
                        if (!!nameList[j]) {
                            better += nameList[j].replace(/^\w/, function (chr) {
                                return chr.toUpperCase();
                            }) + "·";
                        }
                    }
                    better = better.substring(0, better.length - 1);

                    data.name = better;
                    data.key = list[index];
                }
                else {
                    data.key = data.name = list[index];

                }
                result.push(data);
            }

        }
        return result;
    }
    public getUrlPath(str) {
        return (str + "").replace(/^(?:\/\/|[^\/]+)*\//, "").split("?")[0];
    }



    /**
     * 当前URL是否
     * @param data
     */
    public isUrlContains(data: string[]): boolean {
        var url = this.getLocation().href;
        for (var i = 0; i < data.length; ++i) {
            if (url.indexOf(data[i]) > -1) {
                return true;
            }
        }
        return false;
    }

    /**
     * URl的方向是否为
     * @param fromTo
     * @param data
     */
    public isUrlDirectionContains(fromTo: string, data: string[]): boolean {

        var from_t = fromTo.split('->')[0];
        var to_t = fromTo.split('->')[1];


        for (var i = 0; i < data.length; ++i) {
            var from = data[i].split('->')[0];
            var to = data[i].split('->')[1];
            if (
                new RegExp(from).test(from_t) &&
                new RegExp(to).test(to_t)) {
                //   console.log("mactched", fromTo);
                return true;
            }

        };
        return false;
    }

    public IsStrEndWith(str: string, character: string) {
        return !!str && str.substring(str.lastIndexOf(character)) == character;
    }

    private Subscript: Array<Subject<any>> = [];

    public GetOrCreateSubscript(str: string): Observable<any> {
        if (!!this.Subscript[str]) {
        }
        else {
            this.Subscript[str] = new Subject<any>();
        }
        return this.Subscript[str].asObservable();

    }

    public Notify(str, data) {
        if (!!this.Subscript[str]) {

            this.Subscript[str].next(data);
        }

    }

    public Unsubscribe(data) {
        if (!!data && !!data.unsubscribe) {
            data.unsubscribe();
        }
        //if (!!Utility.Subscript[str])
        //Utility.Subscript[str].unsubscribe();
    }

    /**
     * 获取缓存
     * @param str
     * @param fuc
     */
    public GetOrCreateCache(str: string, fuc: Promise<any>, callback, second = 60) {

        CacheService.GetOrCreateCache(str, fuc, callback, second);

    }
    /**
   * 获取缓存
   * @param str
   * @param fuc
   */
    public GetCache(str: string, fuc: Function, callback, second = 60) {

        CacheService.GetCache(str, fuc, callback, second);

    }
    /*
    *
    * 最后一个动作是返回
    */
    public LastActionIsBack = false;

    public windowTop = 0;


    public setTimeout(func, milsecond) {
        var subscript = timer(milsecond, 0).subscribe(p => {
            func();
            subscript.unsubscribe();
        });
        return subscript;
    }

    public clearTimeout(subscript) {
        if (subscript) {
            subscript.unsubscribe();
        }
    }

    public GetCsButton() {
        return '../assets/images/ad-center/cs-button.png';
    }

    public GetCsHoverButton() {
        return '../assets/images/ad-center/cs-hover-button.png';
    }

    public GetCsMsgKey() {
        return '24ypEoyqCRsDthjnGYFjEA';
    }

    public GetTelegramButton() {
        return '../assets/images/ad-center/telegram-button.png';
    }

    public GetTelegramLink() {
        return 'https://t.me/anthony93944';
    }

}



interface CacheContent {
    expiry: number;
    value: any;
}

/**
 * Cache Service is an observables based in-memory cache implementation
 * Keeps track of in-flight observables and sets a default expiry for cached values
 * @export
 * @class CacheService
 */
export class CacheService {
    private static cache: Map<string, CacheContent> = new Map<string, CacheContent>();
    //private inFlightObservables: Map<string, Subject<any>> = new Map<string, Subject<any>>();
    // readonly DEFAULT_MAX_AGE: number = 300000;

    /**
   * 获取缓存
   * @param str
   * @param fuc
   */
    public static GetCache(str: string, fuc: Function, callback, second = 60) {

        //console.log(str);

        if (CacheService.hasValidCachedValue(str)) {
            //console.log(str);
            // var value = clone(this.cache.get(str).value);
            setTimeout(() => callback(CacheService.cache.get(str).value), 0);
        }
        else {
            fuc().then((data) => {
                CacheService.cache.set(str, { value: data, expiry: Date.now() + second * 1000 });
                // console.log(CacheService.cache);

                //this.cache[str] = data;
                callback(data);

            });
            //Cache[str] = result;
            //return result;
        }



    }
    /**
     * 获取缓存
     * @param str
     * @param fuc
     */
    public static GetOrCreateCache(str: string, fuc: Promise<any>, callback, second = 60) {

        //console.log(str);

        if (CacheService.hasValidCachedValue(str)) {
            //console.log(str);
            // var value = clone(this.cache.get(str).value);
            setTimeout(() => callback(CacheService.cache.get(str).value), 0);
        }
        else {
            fuc.then((data) => {
                CacheService.cache.set(str, { value: data, expiry: Date.now() + second * 1000 });
                console.log(CacheService.cache);

                //this.cache[str] = data;
                callback(data);

            });
            //Cache[str] = result;
            //return result;
        }



    }


    /**
     * Checks if the key exists and   has not expired.
     */
    private static hasValidCachedValue(key: string): boolean {
        if (this.cache.has(key)) {
            if (this.cache.get(key).expiry < Date.now()) {
                this.cache.delete(key);
                return false;
            }
            return true;
        } else {
            return false;
        }
    }

    // public static isUrlDirection(destination: string, arrayOrMatch: Array<string>) {
    //     var src = window.location.href;
    //     return this.isUrlDirection(src + "->" + destination, arrayOrMatch);
    // }

    /**
    * URl的方向是否为
    * @param fromTo
    * @param data
    */
    public static isUrlDirectionContains(fromTo: string, data: string[]): boolean {

        var from_t = fromTo.split('->')[0];
        var to_t = fromTo.split('->')[1];


        for (var i = 0; i < data.length; ++i) {
            var from = data[i].split('->')[0];
            var to = data[i].split('->')[1];
            if (
                new RegExp(from).test(from_t) &&
                new RegExp(to).test(to_t)) {
                //   console.log("mactched", fromTo);
                return true;
            }

        };
        return false;
    }


    private static Subscript: Array<Subject<any>> = [];

    public static GetOrCreateSubscript(str: string): Observable<any> {
        if (!!this.Subscript[str]) {
        }
        else {
            this.Subscript[str] = new Subject<any>();

        }

        return this.Subscript[str].asObservable();

    }

    public static Notify(str, data) {
        if (!!this.Subscript[str]) {

            this.Subscript[str].next(data);
        }

    }

    public static Unsubscribe(data) {
        if (!!data && !!data.unsubscribe) {
            data.unsubscribe();
        }
        //if (!!Utility.Subscript[str])
        //Utility.Subscript[str].unsubscribe();
    }

}

export class DeviceInfo {
    public isIPhone: boolean;
    public islargeChromeVersion: boolean;

}
export function translateMembership(membership) {
    switch (true) {
        case membership === 'royalVip':
            return '至尊VIP';
        case membership === 'royalAdmin':
            return '站长';
        case membership === 'vip':
            return '普通会员';
        case membership === 'gvip':
            return '黄金VIP';
        case membership === 'etvip':
            return '网吧会员';
        case membership === 'cpvip':
            return '情侣VIP';
        case membership === 'editor':
            // return '网站编辑';
            return '情侣VIP';
        default:
            return '';
    }
}

export function objectToQueryString(content, key) {
    var list = [];
    if (content) {
        list = objectToList(content)
    }
    list = list.map(l => key + l);
    return list;
}

export function objectToList(obj, keyformat = ""): Array<string> {
    var list = [];
    if (obj != null) {
        Object.keys(obj).forEach(p => {
            var typeOf = typeof (obj[p]);
            if (typeOf != "function" && typeOf != "object") {
                list.push(`${keyformat == "" ? p : keyformat.replace("{0}", p)}=${obj[p]}`);
            }
            else if (Array.isArray(obj[p])) {
                var index = 0;
                (obj[p] as Array<any>).forEach(d => {
                    list = list.concat(objectToList(d, `${p}[${index}][{0}]`));
                    ++index;
                })
            }
            else {
                list = list.concat(objectToList(obj[p], `[${p}].{0}`));
            }
        });
    }

    return list;
}
